export const FORMAT_BUILDER_EN = {
  formatBuilder: 'Format Builder'
}

export const FORMAT_BUILDER_DE = {
  formatBuilder: 'Format Builder'
}
